/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const sliders = document.querySelectorAll('.home-derma-slider');

sliders.forEach((slider, index) => {
    if (slider) {
        // Add unique ID if it doesn't exist
        if (!slider.id) {
            slider.id = `home-derma-slider-${index}`;
        }
        
        var splide = new Splide(slider, {
            type: 'loop',
            rewind: true,
            speed: 1000,
            arrows: false,
            pagination: true,
            perPage: 3,
            perMove: 1,
            gap: '1%',
            breakpoints: {
                1280: {
                    perPage: 2,
                },
                960: {
                    perPage: 1,
                    padding: {
                        right: '10%'
                    },
                },
            }
        });
        splide.mount();
    }
});